var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"600px"}},[_c('v-btn',{staticClass:"sucess",attrs:{"slot":"activator","flat":""},slot:"activator"},[_vm._v("PM Operation")]),_c('v-card',[_c('v-title',[_c('h2',[_vm._v("PM Operation")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }